import axios from 'axios';
import { Storage } from '@stacks/storage';
import { userSession, network, getUserData, authenticatedUserAddress } from './auth';
import { stacksApi, clientNetwork, profileContract } from '../lib/constants';
import { callReadOnlyFunction, cvToJSON, cvToString, cvToValue, principalCV } from '@stacks/transactions';

export const storage = new Storage({ userSession })
// storage.deleteFile('contacts.json')

export const getTransactions = async (principal, offset = 0) => {
  const { data } = await axios.get(`${stacksApi[clientNetwork]}/extended/v2/addresses/${principal}/transactions?offset=${offset}`);
  console.log(data);
  return { transactions: data.results, offset: data.offset + data.results.length };
};

// export const getTransactionAmount = async (principal, txid) => {
//   const { data } = await axios.get(`${stacksApi[clientNetwork]}/extended/v1/address/${principal}/${txid}/with_transfers`);
//   console.log(data);
//   return (data && data.stx_sent && data.stx_received) ? Math.max(parseInt(data.stx_sent, 10), parseInt(data.stx_received, 10)) : 0;
// };

export const getBalance = async (principal) => {
  const { data } = await axios.get(`${stacksApi[clientNetwork]}/extended/v1/address/${principal}/balances`);
  return parseInt(data.stx.balance, 10);
};

export const getPendingTransactions = async (principal, offset = 0) => {
  const { data } = await axios.get(`${stacksApi[clientNetwork]}/extended/v1/address/${principal}/mempool?offset=${offset}`);
  return { transactions: data.results, offset: data.offset + data.results.length };
};

export const findUser = async (userName) => {
  const { data } = await axios.get(`${stacksApi[clientNetwork]}/v1/names/${userName}`)
  // console.log('search result', data)
  return data;
}

export const save = async (data, options) => {
  try {
    const result = await storage.putFile(data.fileName, data.content, options);
    console.log("File Written to Storage: ", data.fileName);
    return { success: true, result }
  } catch (e) {
    console.log('An error occured while trying to save file', e);
    return { success: false, result: {} }

  }
}

export const deleteUploads = async (fileName) => {
  try {
    const result = await storage.deleteFile(fileName);
    return { success: true, result }
  } catch (e) {
    console.log('An error occured while trying to save file', e);
    return { success: false, result: {} }

  }
}

export async function isFileRecoverable(url, validateContent = false) {
  try {
    // Send a GET request to the file URL
    const response = await axios.get(url, { responseType: 'arraybuffer' });

    // Check if the status code indicates success
    if (response.status !== 200) {
      throw new Error(`HTTP status code: ${response.status}`);
    }

    // Optionally validate the file's content
    if (validateContent) {
      const data = response.data;

      // Example validation: Check if the file is not empty
      if (!data || data.length === 0) {
        throw new Error('File content is empty');
      }

      // Additional validation logic can be added here (e.g., check for file type)
    }

    // If everything is fine, return true
    return true;

  } catch (error) {
    console.error(`File is not recoverable: ${error.message}`);
    return false;
  }
}

export const fetchData = async (fileName, options = { decrypt: false, verify: false }) => {
  try {
    const result = await storage.getFile(fileName, options)
    return { success: true, result: JSON.parse(result) }
  } catch (e) {
    return { success: false, result: {}, error: e }
  }
}

export const getNames = async (address, blockchain = 'stacks') => {
  try {
    const { names } = (await axios.get(`${stacksApi[clientNetwork]}/v1/addresses/${blockchain}/${address}`)).data;
    return names.length > 0 ? { success: true, names: names } : { success: false, names: names };
  } catch (e) {
    console.log('Error in get names', e);
    return { success: false, names: [] }
  }
}

async function checkLink(url) { return (await fetch(url)).ok };

export const getSourceUrl = async (btcName, filename, findUrl = false) => {
  try {
    const { zonefile } = (await axios.get(`${stacksApi[clientNetwork]}/v1/names/${btcName}/zonefile`)).data;
    const profileUrl = new RegExp(/https:\/\/(.*)json/).exec(zonefile)[0];
    const profileJson = (await axios.get(profileUrl)).data;
    const hubUrls = profileJson[0].decodedToken.payload.claim.apps;
    if (!findUrl) {
      return `${hubUrls[window.location.origin]}${filename}`;
    } else {
      if (hubUrls[window.location.origin] && await checkLink(`${hubUrls[window.location.origin]}${filename}`)) {
        return `${hubUrls[window.location.origin]}${filename}`;
      }
      for (const hubUrl of Object.values(hubUrls)) {
        console.log(`${hubUrl}${filename}`)
        if (await checkLink(`${hubUrl}${filename}`)) {
          return `${hubUrl}${filename}`;
        }
      }
      return filename;
    }
  } catch (e) {
    console.log('Error in get source url', e);
    return filename;
  }
}


export const saveMute = async (id, reason) => {
  try {
    // Fetch the existing muted data from the file, or create an empty object if the file does not exist
    let mutesData = {};
    const result = await fetchData('mutedlist.json');
    if (result.success) {
      mutesData = result.result;
    }

    // Append the new key/value entry to the muted data
    mutesData[id] = reason;

    // Save the updated muted data to the file
    const dataToSave = {
      content: JSON.stringify(mutesData),
      fileName: 'mutedlist.json'
    };
    const saveResult = await save(dataToSave);
    if (!saveResult.success) {
      throw new Error('Error while saving mute list');
    }

    return mutesData;
  } catch (e) {
    throw new Error('Error while saving mute list', e);
  }
};

export const removeMute = async (id) => {
  try {
    // Fetch the existing muted data from the file
    const result = await fetchData('mutedlist.json');
    if (!result.success) {
      throw new Error('Error while fetching mute list');
    }

    // Remove the key/value entry with the specified ID
    const mutesData = result.result;
    delete mutesData[id];

    // Save the updated muted data to the file
    const dataToSave = {
      content: JSON.stringify(mutesData),
      fileName: 'mutedlist.json'
    };
    const saveResult = await save(dataToSave);
    if (!saveResult.success) {
      throw new Error('Error while saving mute list');
    }

    return mutesData;
  } catch (e) {
    throw new Error('Error while removing muted', e);
  }
};


export const validateUsersContract = async (userStorage) => {
  let state, txId;
  // const for users address
  const usersAddress = authenticatedUserAddress({ network: clientNetwork });
  const userContractId = `${usersAddress}.${profileContract}`;
  // check contract exist for user
  async function checkMempool() {
    let mempoolData, mempool;
    try {
      mempoolData = (await axios.get(`${stacksApi[clientNetwork]}/extended/v1/tx/mempool?sender_address=${usersAddress}`)).data.results;
    } catch (error) { }

    if (mempoolData?.length > 0) {
      mempool = mempoolData.filter((res) => {
        if (res?.smart_contract && res?.smart_contract?.contract_id === userContractId) {
          state = 'mempool';
          txId = res?.tx_id;
          return true
        };
        if (res?.contract_call?.contract_id === userContractId && res?.contract_call?.function_name === 'activate-member') {
          state = 'activationPending';
          txId = res?.tx_id;
          return true;
        }
        return false;
      });
    }
    return { state, txId, inMempool: (mempool?.length > 0) }
  }

  // geting and checking if activate or deploy is in mempool
  const inMempoolState = await checkMempool();
  if (inMempoolState?.inMempool) {
    console.log(inMempoolState);
    return inMempoolState;
  }

  // Validates if contract is latest
  try {
    if (!userStorage) {
      await callReadOnlyFunction({
        contractAddress: usersAddress, contractName: profileContract,
        functionName: 'get-loadout-uri', functionArgs: [],
        network: network({ network: clientNetwork }), senderAddress: usersAddress
      });
    }
  } catch (error) {
    console.log('fired');
    if (error?.message?.match(/UndefinedFunction/)?.[0]) {
      state = 'updateNeeded';
      txId = '';
      console.log({ error }, error?.message?.match(/UndefinedFunction/)[0], { state, txId });
      return { state, txId };
    }
  }

  // getting contract status or checking contract exist's 
  try {
    const activationStatus = cvToValue(await callReadOnlyFunction({
      contractAddress: usersAddress, contractName: profileContract,
      functionName: 'activation-status', functionArgs: [],
      network: network({ network: clientNetwork }), senderAddress: usersAddress
    }))?.value;
    const activationTx = (await axios.get(`${stacksApi[clientNetwork]}/extended/v1/contract/${usersAddress}.${profileContract}`)).data;
    state = activationStatus;
    txId = activationTx?.tx_id;
    console.log({ state, txId });
    return { state, txId };

  } catch (error) {
    console.log({ error });
    if (error?.message?.match(/NoSuchContract/)?.[0]) {
      state = 'notfound';
      txId = '';
      return { state, txId };
    }
  }

  return { state, txId };
};

export const getUserLoadOutUri = async (address) => {
  let userStorage;
  const authedUser = authenticatedUserAddress({ network: clientNetwork });

  // try {
    userStorage = await callReadOnlyFunction({
      contractAddress: address || authedUser,
      contractName: profileContract,
      functionName: 'get-loadout-uri',
      functionArgs: [],
      network: network({ network: clientNetwork }),
      senderAddress: address || authedUser
    });
  // } catch (e) { console.log({ e }); }

  return userStorage = cvToValue(userStorage)?.value?.value;
}